
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/poll",
      function () {
        return require("private-next-pages/poll/index.tsx");
      }
    ]);
  